import React, { ReactNode } from 'react';
import { getModalPortalContainer } from 'utils';
import ReactModal from 'react-modal';
import { XCircle } from 'styled-icons/boxicons-solid';
import styled from 'styled-components';
import { theme } from 'styles/ThemeProvider';
import useViewport from 'hooks/useViewport';

interface Props {
   children: ReactNode;
   isOpen: boolean;
   onRequestClose?: () => void;
   closeButton?: boolean;
}
const Modal: React.FC<Props> = ({ children, isOpen, onRequestClose = () => {}, closeButton = false }) => {
   const [{ width: windowWidth }] = useViewport();
   const styles = {
      overlay: {
         zIndex: 9999,
      },
      content: {
         background: 'transparent',
         top: '50%',
         left: '50%',
         position: 'fixed',
         transform: 'translate(-50%, -50%)',
         padding: '0',
         border: 'none',
         width: '60%',
         minWidth: windowWidth >= 415 ? '375px' : undefined,
         maxWidth: windowWidth >= 415 ? '550px' : undefined,
      },
   };
   return !isOpen ? null : (
      <ReactModal
         isOpen={isOpen}
         contentLabel="Modal"
         //@ts-ignore
         style={styles}
         parentSelector={getModalPortalContainer}
         ariaHideApp={false}
         shouldFocusAfterRender={true}
         shouldCloseOnOverlayClick={true}
         shouldCloseOnEsc={true}>
         <Wrapper>
            {closeButton && (
               <CloseButton onClick={onRequestClose}>
                  <XCircle size={27} color={theme.primaryBlueDark} cursor="pointer" />
               </CloseButton>
            )}
            {children}
         </Wrapper>
      </ReactModal>
   );
};
export default Modal;

const Wrapper = styled.div`
   position: relative;
   background-color: ${theme.primaryWhite};
   border: solid 1px ${theme.primaryGrey};
   border-radius: 8px;
   //min-width: 374px;
   padding: 15px 5px;
   box-shadow: 0 14px 26px 0 rgba(0, 0, 0, 0.09);
   @media only screen and (max-width: 415px) {
      padding: unset;
   }
`;

const CloseButton = styled.button`
   position: absolute;
   top: 0;
   right: 0;
   border: none;
   background: transparent;
   padding: 10px;
`;
